import React from "react";

import { Box, Stack, Typography } from "@mui/material";
import { Info } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

import { HelpBox } from "@/components/atoms";
import { toRounded } from "@/utils";


interface StatBoxProps {
  name: string;
  value: number;
  valueFormatter?: (value: number) => number | string;
  icon?: React.ReactNode;
  disabled?: boolean;
  help?: string;
  estimate?: boolean;
}

const StatBox: React.FC<StatBoxProps> = ({
  name,
  value,
  valueFormatter = toRounded,
  icon,
  disabled = false,
  help,
  estimate = false
}) => {
  const theme = useTheme();

  return (
    <Stack
      spacing={2}
      border={1}
      borderRadius={1}
      borderColor={theme.palette.divider}
      p={2}
      minWidth={"144px"}
    >
      <Stack spacing={1} direction="row" alignItems="flex-end">
        {icon}
        <Typography variant="body2">{name}</Typography>
        {help && (
          <HelpBox title={help}>
            <Info fontSize="small" color="info" />
          </HelpBox>
        )}
      </Stack>
      <Box display="flex" justifyContent="center">
        <Typography
          variant="h4"
          color={disabled ? "textSecondary" : "textPrimary"}
        >
          {`${valueFormatter(value)}${estimate ? "*" : ""}`}
        </Typography>
      </Box>
    </Stack>
  );
};

export default StatBox;
